export function getInsertionSortAnimation(array){
    const animations = [];
    if(array.length<=1)return array;
    insertionSortHelper(array,animations);
    return animations;
}

function insertionSortHelper(array,animations){
    let key = 0;
    let j=0;
    for(let i=1;i<array.length;i++){
        key = array[i];
        j=i-1;
        if(j>=0){
            animations.push([j,i]);
            animations.push([j,i]);
        }
        while(j>=0 && array[j]>key){
            array[j+1] = array[j];
            animations.push([1,j+1,j]);
            j=j-1;
            animations.push([j,i]);
            animations.push([j,i]);
        }
        array[j+1]=key;
        animations.push([2,j+1,key]);
    }
}